import { GuaranteeDto } from "api/pricing";
import { FC, useCallback, useMemo } from "react";
import { isGuaranteeAvailable } from "../guarantees-card/config/guaranteeDependenciesConfig";

interface GuaranteeButtonProps {
  guarantee: GuaranteeDto;
  currentGuaranteeIds: string[];
  guaranteesReferential: GuaranteeDto[];
  onToggle: (guarantee: GuaranteeDto) => void;
}

const BASE_CLASS = "text-sm py-0 px-1.5 rounded-full transition-all duration-200 focus:outline-none";

export const GuaranteeButton: FC<GuaranteeButtonProps> = ({
  guarantee,
  currentGuaranteeIds,
  guaranteesReferential,
  onToggle
}) => {
  const isActive = currentGuaranteeIds.includes(guarantee.id);
  const isRequired = guarantee.isRequired;
  const isAvailable = isGuaranteeAvailable(guarantee.name, currentGuaranteeIds, guaranteesReferential);
  const isDisabled = isRequired || (!isActive && !isAvailable);

  const handleClick = useCallback(() => {
    onToggle(guarantee);
  }, [onToggle, guarantee]);

  const buttonClassName = useMemo(() => {
    if (isRequired) {
      return `${BASE_CLASS} text-primary border border-primary cursor-default`;
    }
    if (isActive) {
      return `${BASE_CLASS} text-primary border border-primary hover:opacity-70 cursor-pointer`;
    }
    if (isAvailable) {
      return `${BASE_CLASS} text-gray-500 border border-gray-400 border-dashed hover:border-primary hover:text-primary cursor-pointer`;
    }
    return `${BASE_CLASS} text-gray-400 border border-gray-300 border-dashed cursor-default`;
  }, [isRequired, isActive, isAvailable]);

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDisabled}
      className={buttonClassName}
    >
      {guarantee.shortName || guarantee.name}
    </button>
  );
};
